import React, { useState, useEffect } from 'react';
import InputNumber from './InputNumber.js';
import './InputNumber.css';

export default function RoomsGuestsSelector(props) {

    const [rooms, setRooms] = useState(props.selectedRooms);
    const [roomCount, setRoomCount] = useState(props.selectedRooms.length);
    const [adultsCount, setAdultsCount] = useState(rooms.reduce((accum, item) => accum + item.adults, 0))
    const [childrenCount, setChildrenCount] = useState(rooms.reduce((accum, item) => accum + item.children, 0))

    useEffect(() => {
        // if opened in 'add' mode call addRoom()
        
        if (props.mode === 'add') {

            addRoom();

        }
        
    }
        , []);

    const maxCapacityRoomType = props.roomTypes.sort((a, b) => {
        return b.maxCapacity - a.maxCapacity;
    })[0];

    function guestCount() {
        return adultsCount + childrenCount;
    }

    function apply() {
        props.apply(rooms);
    }

    function close() {
        props.close();
    }

    function addRoom() {
        let r = rooms;
        r.push({ adults: 2, children: 0 });
        setRooms(r);
        setRoomCount(r.length);
        setAdultsCount(r.reduce((accum, item) => accum + item.adults, 0));
        setChildrenCount(r.reduce((accum, item) => accum + item.children, 0))
    }

    function cancel() {
        //remove last room
        //rooms.pop();
        props.close();
    }

    function removeRoom(i) {
        let r = rooms;
        r.splice(i, 1);
        setRooms(r);
        setRoomCount(r.length)
        setAdultsCount(r.reduce((accum, item) => accum + item.adults, 0));
        setChildrenCount(r.reduce((accum, item) => accum + item.children, 0))
    }

    function changeAdults(index, value) {
        let r = rooms;
        r[index].adults = value;
        setRooms(r)
        setAdultsCount(rooms.reduce((accum, item) => accum + item.adults, 0));
    }

    function changeChildren(index, value) {
        let r = rooms;
        r[index].children = value;
        setRooms(r);
        setChildrenCount(rooms.reduce((accum, item) => accum + item.children, 0))
    }

    return (
        <div>

            <div class="row" style={{margin: 'auto'}}>
                <button type="button"
                    class="close col-1 bg-white"
                    aria-label="Close"
                    onClick={() => close() }
                >

                    <span aria-hidden="true">&times;</span>

                </button>

                <span class="col align-bottom"><strong>
                    {props.mode === 'add' ? 'Add Room Occupants' : 'Room Occupants'}</strong>
                </span>

            </div>

            <div>

                {rooms.map((room, index) => 
                    <div className={(props.mode === 'add' && index < rooms.length - 1) ? 'hidden' : ''} >
                        <div className='row'>
                            <div className='col'>
                                <div className="row">
                                    <div className="col">
                                        <h6>
                                            {'Room ' + (index + 1) } 
                                        </h6>
                                    </div>
                                    {rooms.length > 1 && 
                                        <div className="col text-right">
                                            <span>
                                                <a
                                                href="" 
                                                onClick={(e) => { e.preventDefault(); removeRoom(index) } }
                                                > remove</a>
                                            </span>
                                        </div>}
                                </div>
                                <div class="row">
                                    <div className="col">
                                        <div className="align-middle" style={{height: '38px', lineHeight: '38px', marginLeft: '12px'}}>Adults</div>

                                    </div>
                                    <div class="col">
                                        <InputNumber min={1} max={maxCapacityRoomType.maxCapacity - room.children} value={room.adults} onChange={(v) => changeAdults(index, v) }/>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col">
                                        <div className="align-middle" style={{ height: '38px', lineHeight: '38px', marginLeft: '12px' }}>Children</div>
                                    </div>
                                    <div class="col">
                                        <InputNumber min={0} max={maxCapacityRoomType.maxCapacity - room.adults} value={room.children} onChange={(v) => changeChildren(index, v)} />
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                        <hr style={{ marginTop: '0.5rem', marginBottom: '0.5rem'}}/>
                    </div>
                    )
                }

                <div className={"row" + props.mode==='add'?" hidden":""}>
                    <div className="col">
                        <div>
                            <button type="button" class="btn btn-link" style={{}} onClick={() => addRoom()}>add another room</button>
                        </div>
                    </div>
                </div>

            </div>

            <div class="d-flex ">
                <div className={props.mode === 'add' ? " hidden" : ""}>
                    <h6 class="mr-auto p-2">{(roomCount.toString() + ' room') + (roomCount !== 1 ? 's, ' : ', ') + 
                        (guestCount().toString() + ' guest') + (guestCount() !== 1 ? 's, ' : ', ')}</h6>
                </div>
                <button
                    type="button"
                    className="btn btn-default "
                    onClick={() => close()}
                >Close</button>
                <button
                    type="button"
                    class="btn btn-primary "
                    onClick={() => apply()}
                >APPLY</button>
            </div>

        </div>
        
        );

}